import {O, RunInAction} from "web-vcore";
import * as THREE from "three";
import {GetStatDayContainingX} from "../../../UI/Stats/Helpers.js";
import {Timer} from "js-vextensions";
import {store} from "../../index.js";
import {ignore} from "mobx-sync";

export const TimingState_updaterForInterval1s = new Timer(1000, ()=>{
	RunInAction("TimingState_updaterForInterval1s", ()=>{
		const state = store.main.timing;
		const now = Date.now();
		{
			const newVal = now.FloorTo(1000);
			if (newVal != state.currentTime_throttledTo1s) {
				state.currentTime_throttledTo1s = newVal;
			}
		}
		{
			const newVal = GetStatDayContainingX(now);
			if (newVal != state.currentStatDay_startTime) {
				state.currentStatDay_startTime = newVal;
			}
		}
	});
}).Start();

export class TimingState {
	@O @ignore accessor currentTime_throttledTo1s = 0;

	@O @ignore accessor currentStatDay_startTime = GetStatDayContainingX(Date.now()); // updated by timer above
	//@O @ignore currentStatNight_startTime = GetStartOfStatNightContainingX(Date.now()); // updated by timer above
}

export function GetNow_TrackedAndThrottled(throttleInterval: 1000) {
	return store.main.timing.currentTime_throttledTo1s;
}